import { render } from "./FilterToko.vue?vue&type=template&id=50764cc0"
import script from "./FilterToko.vue?vue&type=script&lang=js"
export * from "./FilterToko.vue?vue&type=script&lang=js"
script.render = render

export default script